import GlobalStyles from '@mui/material/GlobalStyles';
import { useTheme } from '@mui/material/styles';

import { LoginPage } from './LoginPage.js';

const LoginPageWrapper = () => {
  const theme = useTheme();

  return (
    <>
      <GlobalStyles
        styles={{
          '& html body': {
            backgroundColor: theme.palette.background.paper,
          },
        }}
      />
      <LoginPage />
    </>
  );
};

export default LoginPageWrapper;
